import React from 'react';

export default function Content() {
  return (
    <>
      <div className="s1_1_content">
        <div className="txt-center prt-regular fs-22 fc-black1 mb-2">
          About us
        </div>
        <div className="txt-center prt-bold fs-45 fc-black1 mb-3 lh-14">
          <span className="fc-005eed">AI 서비스 로봇 전문기업 크림봇</span>이
          제안하는&nbsp;
          <br className="m-none" />
          <span>다양한 혜택</span>을 <br className="pc-none" /> 직접
          확인해보세요.
        </div>
        <div className="txt-center prt-regular fs-20 fc-40 lh-15 mb-4">
          크림봇은 서비스 로봇 솔루션 분야의 전문 기업으로,{' '}
          <br className="m-none" />
          전 세계적으로 그 역량을 인정받는 선도 기업입니다. <br />
          <br />
          우리는 외식업, 호텔, 의료, 산업, 교육, 사무, 매장, <br />
          물류, 실내 골프 연습장, 엔터테인먼트 등 <br />
          다양한 분야에서 효율적이고 혁신적인 로봇 솔루션을 제공합니다.
        </div>

        <div className="s1_1_mid_img w-100"></div>

        <div className="txt-center prt-regular fs-20 fc-40 lh-15 mt-4 mb-10">
          크림봇의 로봇은 매장 공간에 최적화된 맞춤형 추천을 바탕으로
          <br className="m-none" />
          매년 증가하는 인건비 부담을 줄이며, 안정적이고 정확한 이동을
          실현합니다.
          <br />
          <br />
          뿐만 아니라, 크림봇의 IT 서비스는 자율주행 서빙과 안내 기능은 물론,
          <br className="m-none" />
          로봇 전문가의 케어 서비스와 전문 상담을 통해 일상에 더욱 편리함과
          향상된 혜택을 더해드립니다.
          <br />
          <br />
          <span className="txt-center prt-bold  fs-20 fc-40">
            크림봇과 함께라면, 다양한 상황에 꼭 맞는 운영 솔루션을 경험하며&nbsp;
            <br className="m-none" />
            <span className="fc-005eed">
              더 나은 미래를 함께 만들어갈 수 있습니다.
            </span>
          </span>
        </div>
      </div>
    </>
  );
}
